import { Chip, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { ReactElement } from 'react';

const styles: Record<string, SxProps<Theme>> = {
    light: {
        backgroundColor: (theme: Theme) =>
            theme.palette.mode === 'light'
                ? 'background.paper'
                : theme.palette.mask.black['60p'],
        color: (theme: Theme) =>
            theme.palette.mode === 'light' ? 'text.body' : 'primary.main',
    },
    transparent: {
        color: 'text.body',
        backgroundColor: 'action.hover',
        '& .MuiChip-icon': {
            color: 'text.body',
        },
    },
    darkTransparent: {
        color: 'primary.contrastText',
        backgroundColor: 'action.active',
        '& .MuiChip-icon': {
            color: 'primary.contrastText',
        },
    },
};

interface ChipLabelProps {
    label?: string;
    icon?: ReactElement;
    variant?: 'light' | 'transparent' | 'darkTransparent';
    sx?: SxProps<Theme>;
}
export function ChipLabel({
    label,
    icon,
    variant = 'transparent',
    sx,
}: ChipLabelProps) {
    return (
        <Chip
            clickable={false}
            sx={sxAppend(styles[variant], sx)}
            trackButton="NotMapped"
            label={label}
            icon={icon}
        />
    );
}
